import { render, staticRenderFns } from "./repairremind.vue?vue&type=template&id=7fd65596&scoped=true&"
import script from "./repairremind.vue?vue&type=script&lang=js&"
export * from "./repairremind.vue?vue&type=script&lang=js&"
import style0 from "./repairremind.vue?vue&type=style&index=0&id=7fd65596&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fd65596",
  null
  
)

export default component.exports